// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__dbCHd","ThumbZoom":"ChapterPlayer_ThumbZoom__1GNgo"};